<template>
    <div>

    </div>
</template>

<script>

import { cioanalytics } from '@/main'; // adjust path if needed

export default {
    mounted(){
        this.logout();
    },
    methods: {
        logout() {
            //window.Bugpilot.logout();
            this.$store.commit('SET_PRODUCT_TYPE', null);
            if(this.removeCarItems()) {
                // We have items.
                cioanalytics.track('logout_with_cartItems', { hadItems: true });
            }
        },
        removeCarItems() {
            let hadItems = false;
            this.$store.dispatch('cart/list').then((res) => {
                res.items.forEach((elem) => {
                    hadItems = true;
                    this.removeCartItem(elem.id)
                })
                this.$store.dispatch('logout');
            });

            return hadItems;
        },
    },
};
</script>

